import { IconManifest } from 'app/agriculture/icons/types';

import { MapIconOptions } from './types';
import { svgStringToDataUri } from './svgStringToDataUri';
import { OverlayIcon } from './OverlayIcon';

export function createOverlayIconDataUri(icon: IconManifest, options: MapIconOptions = {}) {
    return svgStringToDataUri(OverlayIcon({ icon, ...options }));
}
